import {NgModule} from '@angular/core';
import {PagingComponent} from './paging/paging.component';
import {HttpClientModule} from "@angular/common/http";
import {
    NzButtonModule,
    NzCheckboxModule,
    NzInputModule,
    NzPaginationModule,
    NzRadioModule,
    NzSelectModule,
    NzUploadModule
} from "ng-zorro-antd";
import {ValidateRuleDirective} from './forms/validate-rule/validate-rule.directive';
import {FormItemComponent} from './forms/form-item/form-item.component';
import {SelectComponent} from "./forms/select/select.component";
import {FormsModule} from "@angular/forms";
import {CommonModule, registerLocaleData} from "@angular/common";
import {RadiosComponent} from './forms/radios/radios.component';
import {CheckboxsComponent} from './forms/checkboxs/checkboxs.component';
import {PriceInputComponent} from './forms/price-input/price-input.component';
import {FormDirective} from './forms/form.directive';
import {UploadComponent} from './forms/upload/upload.component';
import {ConvertNumberPipe} from './pipes/convert-number.pipe';
import {ConvertCurrencyPipe} from './pipes/convert-currency.pipe';
import {PermissionDirective} from './permission/permission.directive';
import zh from "@angular/common/locales/zh";
import { FormItemLabelComponent } from './forms/form-item-label/form-item-label.component';

registerLocaleData(zh);

@NgModule({
    imports: [
        CommonModule,
        FormsModule,

        NzPaginationModule,
        NzUploadModule,
        NzCheckboxModule,
        NzRadioModule,
        NzInputModule,
        NzSelectModule,
        NzButtonModule,

        HttpClientModule
    ],
    declarations: [
        CheckboxsComponent,
        FormItemComponent,
        PriceInputComponent,
        RadiosComponent,
        SelectComponent,
        UploadComponent,
        ValidateRuleDirective,
        FormDirective,
        PagingComponent,
        ConvertNumberPipe,
        ConvertCurrencyPipe,
        PermissionDirective,
        FormItemLabelComponent,
    ],
    exports: [
        CheckboxsComponent,
        FormItemComponent,
        FormItemLabelComponent,
        PriceInputComponent,
        RadiosComponent,
        SelectComponent,
        UploadComponent,
        ValidateRuleDirective,
        FormDirective,
        PagingComponent,
        ConvertNumberPipe,
        ConvertCurrencyPipe,
        PermissionDirective,

        NzPaginationModule,
        NzUploadModule,
        NzCheckboxModule,
        NzRadioModule,
        NzInputModule,
        NzSelectModule,
        NzButtonModule
    ]
})
export class NgCclModule {
}
